// services/user.service.local.js

import { storageService } from '../async-storage.service'
import { utilService } from '../../services/util.service'

const STORAGE_KEY = 'user'
const STORAGE_KEY_LOGGEDIN_USER = 'loggedinUser'

export const userService = {
  login,
  logout,
  signup,
  getUsers,
  getById,
  remove,
  update,
  getLoggedinUser,
  updateUserProfile,
  saveLoggedinUser,
}

// פונקציה להחזרת רשימת המשתמשים (ללא סיסמאות)
async function getUsers() {
  const users = await storageService.query(STORAGE_KEY)
  return users.map((user) => {
    delete user.password
    return user
  })
}

// קבלת משתמש לפי ID
async function getById(userId) {
  const user = await storageService.get(STORAGE_KEY, userId)
  if (user) delete user.password
  return user
}

// הסרת משתמש
function remove(userId) {
  return storageService.remove(STORAGE_KEY, userId)
}

// עדכון משתמש
async function update(userDetails) {
  if (!userDetails._id) throw new Error('User _id is missing')

  const user = await storageService.get(STORAGE_KEY, userDetails._id)
  if (!user) throw new Error('User not found')

  // Update fields
  user.nickname = userDetails.nickname || user.nickname
  user.email = userDetails.email || user.email
  user.usertag = userDetails.usertag || user.usertag
  user.image = userDetails.image || user.image
  user.role = userDetails.role || user.role
  user.comments = userDetails.comments || user.comments
  user.posts = userDetails.posts || user.posts

  await storageService.put(STORAGE_KEY, user)

  // Update logged-in user if it's the same user
  const loggedinUser = getLoggedinUser()
  if (loggedinUser && loggedinUser._id === user._id) saveLoggedinUser(user)

  return user
}

// התחברות משתמש
async function login({ email, password }) {
  const users = await storageService.query(STORAGE_KEY)
  const user = users.find(
    (user) => user.email === email && user.password === password
  )
  if (user) {
    saveLoggedinUser(user)
    delete user.password
    return user
  } else {
    throw new Error('Invalid email or password')
  }
}

// הרשמת משתמש חדש
async function signup(userCred) {
  const users = await storageService.query(STORAGE_KEY)
  const userExists = users.some((user) => user.email === userCred.email)
  if (userExists) throw new Error('Email already in use')

  const user = {
    nickname: userCred.nickname,
    email: userCred.email,
    password: userCred.password,
    usertag: userCred.usertag || 'משתמש רשום',
    image:
      userCred.image ||
      `https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/user-icon-default_olftzk.svg`,
    role: 'user',
    comments: [],
    posts: [],
  }

  await storageService.post(STORAGE_KEY, user)
  saveLoggedinUser(user)
  return user
}

// התנתקות משתמש
function logout() {
  sessionStorage.removeItem(STORAGE_KEY_LOGGEDIN_USER)
}

// קבלת המשתמש המחובר
function getLoggedinUser() {
  return JSON.parse(sessionStorage.getItem(STORAGE_KEY_LOGGEDIN_USER))
}

// שמירת המשתמש המחובר
function saveLoggedinUser(user) {
  const safeUser = { ...user }
  delete safeUser.password
  sessionStorage.setItem(STORAGE_KEY_LOGGEDIN_USER, JSON.stringify(safeUser))
  return safeUser
}

// יצירת משתמש מנהל (לא חובה, לצורכי בדיקה)
// _createAdmin()
async function _createAdmin() {
  const users = await storageService.query(STORAGE_KEY)
  const adminExists = users.some((user) => user.email === 'a@a.com')
  // if (adminExists) return

  const adminUser = {
    id: utilService.makeId(),
    nickname: '12אדמינוב',
    email: 'a@a',
    password: 'a', // יש להצפין סיסמאות ביישום אמיתי
    usertag: 'Site Owner',
    image: `https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/user-icon-default_olftzk.svg`,
    role: 'admin',
    posts:[],
  }

  await storageService.post(STORAGE_KEY, adminUser)
}


async function updateUserProfile(updates) {
  const loggedinUser = getLoggedinUser()
  if (!loggedinUser || !loggedinUser._id) {
    throw new Error('No user is signed in')
  }

  // נשלב את העדכונים עם המשתמש המחובר
  const updatedUser = { ...loggedinUser, ...updates }
  return await update(updatedUser)
}